import axios from 'axios';
import configService from '@/services/configService';

export default {
  async login(mobile, password) {
    return axios
      .post(`${configService.get('apiUrl')}/admin/login`, {
        mobile,
        password
      })
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
